export const environment = {
	production: false,
	baseUrl: 'https://apipp.360city.pt/v1/',
	app: '360City - Pagamento',
	version: '1.0.0'
};
